import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=75588f6c&scoped=true&"
import script from "./product-category.js?vue&type=script&lang=js&"
export * from "./product-category.js?vue&type=script&lang=js&"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=75588f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75588f6c",
  null
  
)

export default component.exports